import { FC, SVGProps } from "react"
import { publicIcons } from "./publicIcons"

export type IconComponent = FC<SVGProps<SVGSVGElement>>

// Every icon known so far: the public set at once, the platform set once it has loaded.
const icons: Record<string, IconComponent> = { ...publicIcons }
let version = 0
const listeners = new Set<() => void>()
let platformLoad: Promise<void> | null = null

export const getIcon = (name: string): IconComponent | undefined => icons[name]

/** Adds icons and re-renders every SvgIcon that was waiting for one. */
export const registerIcons = (more: Record<string, IconComponent>): void => {
  Object.assign(icons, more)
  version++
  listeners.forEach(listener => listener())
}

/** Loads the platform icon chunk once; a no-op after it has loaded (or while it is loading). */
export const loadPlatformIcons = (): Promise<void> =>
  (platformLoad ??= import("./platformIcons")
    .then(module => registerIcons(module.platformIcons))
    .catch(error => {
      platformLoad = null
      console.error("[icons] platform icons failed to load", error)
    }))

export const subscribeToIcons = (listener: () => void): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const getIconsVersion = (): number => version
